import { render } from "./Recovery.vue?vue&type=template&id=3295ea1a&ts=true"
import script from "./Recovery.vue?vue&type=script&lang=ts"
export * from "./Recovery.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\Anton\\Workspaces\\htdocs\\devloader-userspace\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__